import React, { Component } from "react";
import "react-phone-number-input/style.css";
import Api from "../../Api";
import Form from "../../components/Form";
import InputField from "../../components/InputField";
import LinkedFieldContainer from "../../components/LinkedFieldContainer";

class ZVHC2Form extends Component {
  constructor(props) {
    super(props);

    this.state = {
      defDossier: 3518,
      showModal: false,
      loading: false,
      isMelding: true,
    };

    this.submitForm = this.submitForm.bind(this);
  }

  async submitForm(data) {
    try {
      this.setState({ loading: true });

      await Api.dossiers.Create({
        defDossier: this.state.defDossier,
        ...data,
      });
      this.props.reset();
      this.setState({ loading: false, showModal: true });
    } catch (error) {
      this.setState({ loading: false });
   
    }
  }

  render() {
    return (
      <>
        {this.state.loading && (
          <div className="flex items-center justify-center h-screen fixed w-full z-50">
            <div className="bg-slate-500 absolute w-full h-full  opacity-50"></div>
            <div class="relative">
              <div className="h-24 w-24 rounded-full border-t-8 border-b-8 border-slate-200"></div>
              <div className="absolute top-0 left-0 h-24 w-24 rounded-full border-t-8 border-b-8 border-slate-300 animate-spin"></div>
            </div>
          </div>
        )}
        {this.state.showModal && (
          <div
            id="successModal"
            tabindex="-1"
            aria-hidden="true"
            class="flex  overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-modal md:h-full"
          >
            <div className="bg-slate-500 absolute w-full h-full opacity-50"></div>
            <div class="relative p-4 w-full max-w-md h-full md:h-auto">
              <div class="relative p-4 text-center bg-white rounded-lg shadow dark:bg-gray-800 sm:p-5">
                <button
                  onClick={() => {
                    this.setState({ showModal: false });
                  }}
                  type="button"
                  class="text-gray-400 absolute top-2.5 right-2.5 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                  data-modal-toggle="successModal"
                >
                  <svg
                    aria-hidden="true"
                    class="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                  <span class="sr-only">Close modal</span>
                </button>
                <div class="w-12 h-12 rounded-full bg-green-100 dark:bg-green-900 p-2 flex items-center justify-center mx-auto mb-3.5">
                  <svg
                    aria-hidden="true"
                    class="w-8 h-8 text-green-500 dark:text-green-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                  <span class="sr-only">Success</span>
                </div>
                <p class="mb-4 text-lg font-semibold text-gray-900 dark:text-white">
                  Successfully!
                </p>
                <button
                  onClick={() => {
                    this.setState({ showModal: false });
                    this.props.reset();
                  }}
                  type="button"
                  class="py-2 px-3 text-sm font-medium text-center text-white rounded-lg bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 "
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="p-5 flex flex-col items-center gap-5">
          <div className=" d-flex justify-content-center w-full">
            <img
              src="https://next.kedo.nu/images/environment/235/logo.png"
              alt="logo"
              className="img-thumbnail w-36 h-3w-36"
            />
          </div>
          <h1 className="text-3xl font-bold underline pt-2">ProtehaMi</h1>
          <div className=" lg:[50%] shadow p-4 rounded bg-slate-50">
            {this.state.isMelding ? (
              <Form
                className="flex flex-col gap-4 w-full items-start"
                {...this.props}
                onSubmit={this.submitForm}
                defDossier={this.state.defDossier}
              >
                <div className="flex gap-5 flex-wrap">
                  <div className="flex flex-col gap-2">
                    <InputField
                      type="date"
                      defaultValue={new Date().toLocaleDateString("en-CA")}
                      name={"70226"}
                      rules={{
                        required: {
                          value: true,
                          message: "Datum aanmelding is required",
                        },
                      }}
                      {...this.props}
                      errors={this.props.formState.errors}
                      hide
                    />
                    <InputField
                      defaultValue={35177}
                      type="select"
                      label="Wat wilt u registreren?"
                      name={"70213"}
                      rules={{ required: true }}
                      {...this.props}
                      errors={this.props.formState.errors}
                      options={[
                        {
                          value: 35177,
                          label: "Melding",
                        },
                        {
                          value: 35176,
                          label: "Advies",
                        },
                      ]}
                      onChange={(value) => {
                        this.setState({ isMelding: value == 35177 });
                      }}
                    />

                    <>
                      <InputField
                        type="text"
                        label="Naam contactpersoon ProtehaMi"
                        name={"70426"}
                        rules={{ required: true }}
                        {...this.props}
                        errors={this.props.formState.errors}
                      />

                      <InputField
                        type="select"
                        label="Welke punten zijn van u op toepassing?"
                        name={"70424"}
                        rules={{ required: true }}
                        {...this.props}
                        errors={this.props.formState.errors}
                        options={[
                          {
                            value: 35208,
                            label:
                              "De vijf stappen van de beschermingscode zijn NIET doorlopen.",
                          },
                          {
                            value: 35207,
                            label:
                              "De vijf stappen van de beschermingscode zijn doorlopen.",
                          },
                          {
                            value: 35206,
                            label:
                              "Anoniem blijven ten opzichte van de directe betrokkenen/slachtoffer.",
                          },
                          {
                            value: 35205,
                            label: "Een melding van kindermishandeling.",
                          },
                          {
                            value: 35204,
                            label: "Een melding van relationeel geweld.",
                          },
                        ]}
                      />

                      <InputField
                        type="text"
                        label="Naam melder"
                        name={"70428"}
                        rules={{ required: true }}
                        {...this.props}
                        errors={this.props.formState.errors}
                      />
                      <InputField
                        type="text"
                        label="Instantie melder"
                        name={"70429"}
                        rules={{ required: true }}
                        {...this.props}
                        errors={this.props.formState.errors}
                      />
                      <InputField
                        type="phone"
                        label="Telefoonnummers"
                        name={"70430"}
                        rules={{ required: "This field is required" }}
                        {...this.props}
                        errors={this.props.formState.errors}
                      />

                      <InputField
                        type="email"
                        label="E-mailadres melder"
                        name={"70431"}
                        rules={{ required: true }}
                        {...this.props}
                        errors={this.props.formState.errors}
                      />
                      <InputField
                        type="text"
                        label="Relatie tot slachtoffer"
                        name={"70433"}
                        rules={{ required: true }}
                        {...this.props}
                        errors={this.props.formState.errors}
                      />
                      <InputField
                        type="select"
                        label="Is er vooraf overleg geweest met ProtehaMi?"
                        name={"70432"}
                        rules={{ required: true }}
                        {...this.props}
                        errors={this.props.formState.errors}
                        options={[
                          {
                            value: 15934,
                            label: "Ja",
                          },
                          {
                            value: 15930,
                            label: "Nee",
                          },
                        ]}
                      />
                      <InputField
                        type="select"
                        label="Zijn de betrokkenen op de hoogte van het feit dat u meldt?"
                        name={"70434"}
                        rules={{ required: true }}
                        {...this.props}
                        errors={this.props.formState.errors}
                        options={[
                          {
                            value: 15934,
                            label: "Ja",
                          },
                          {
                            value: 15930,
                            label: "Nee",
                          },
                        ]}
                      />
                      <InputField
                        type="select"
                        label="Is de inhoud van de melding besproken?"
                        name={"70436"}
                        rules={{ required: true }}
                        {...this.props}
                        errors={this.props.formState.errors}
                        options={[
                          {
                            value: 15934,
                            label: "Ja",
                          },
                          {
                            value: 15930,
                            label: "Nee",
                          },
                        ]}
                      />
                      <InputField
                        type="text"
                        label="Zo ja met wie is de melding besproken?"
                        name={"70437"}
                        rules={{ required: true }}
                        {...this.props}
                        errors={this.props.formState.errors}
                      />
                    </>
                  </div>
                  <div className="flex flex-col gap-2">
                    <LinkedFieldContainer
                      displayId={"70445"}
                      defdossierId={"1818"}
                    >
                      <InputField
                        type="text"
                        label="Voorletters"
                        name={"31212"}
                        rules={{ required: true }}
                        {...this.props}
                        errors={this.props.formState.errors}
                      />
                      <InputField
                        type="text"
                        label="Voornamen"
                        name={"31201"}
                        rules={{ required: true }}
                        {...this.props}
                        errors={this.props.formState.errors}
                      />
                      <InputField
                        type="text"
                        label="Achternaam"
                        name={"31217"}
                        rules={{ required: true }}
                        {...this.props}
                        errors={this.props.formState.errors}
                      />
                      <InputField
                        type="email"
                        label="E-mail"
                        name={"31227"}
                        rules={{ required: true }}
                        {...this.props}
                        errors={this.props.formState.errors}
                      />
                      <InputField
                        type="phone"
                        label="Telefoon"
                        name={"31205"}
                        rules={{ required: "This Field Is Required" }}
                        {...this.props}
                        errors={this.props.formState.errors}
                      />
                      <InputField
                        type="date"
                        label="Geboortedatum"
                        name={"31453"}
                        rules={{ required: "This Field Is Required" }}
                        {...this.props}
                        errors={this.props.formState.errors}
                      />
                      <InputField
                        type="select"
                        label="Geslacht"
                        name={"31256"}
                        rules={{ required: true }}
                        {...this.props}
                        errors={this.props.formState.errors}
                        options={[
                          {
                            value: 15943,
                            label: "Onbekend",
                          },
                          {
                            value: 15941,
                            label: "Vrouw",
                          },
                          {
                            value: 15938,
                            label: "Man",
                          },
                        ]}
                      />

                      <InputField
                        type="text"
                        label="CRIB"
                        name={"31254"}
                        rules={{ required: true }}
                        {...this.props}
                        errors={this.props.formState.errors}
                      />
                      <InputField
                        type="text"
                        label="Identiteitsnummer"
                        name={"31260"}
                        rules={{ required: true }}
                        {...this.props}
                        errors={this.props.formState.errors}
                      />
                      <InputField
                        type="text"
                        label="Geboorteplaats"
                        name={"32978"}
                        rules={{ required: true }}
                        {...this.props}
                        errors={this.props.formState.errors}
                      />
                      <InputField
                        type="select"
                        label="Gezag berust bij"
                        name={"71885"}
                        rules={{ required: true }}
                        {...this.props}
                        errors={this.props.formState.errors}
                        options={[
                          {
                            value: 35637,
                            label: "Familielid",
                          },
                          {
                            value: 35636,
                            label: "Pleegouders",
                          },
                          {
                            value: 35635,
                            label: "Moeder",
                          },
                          {
                            value: 35634,
                            label: "Vader",
                          },
                          {
                            value: 35633,
                            label: "Ouders",
                          },
                        ]}
                      />
                      <InputField
                        type="text"
                        label="Opmerking"
                        name={"32975"}
                        rules={{ required: true }}
                        {...this.props}
                        errors={this.props.formState.errors}
                      />
                    </LinkedFieldContainer>
                  </div>
                  <div className="flex flex-col gap-2">
                    <InputField
                      type="textarea"
                      label="Wat gebeurt/ gebeurde er feitelijk (aard/ernst en duur)"
                      name={"70439"}
                      rules={{ required: true }}
                      {...this.props}
                      errors={this.props.formState.errors}
                    />
                    <InputField
                      type="select"
                      label="Wat verwacht u van ProtehaMi?"
                      name={"70440"}
                      rules={{ required: true }}
                      {...this.props}
                      errors={this.props.formState.errors}
                      options={[
                        {
                          value: 35212,
                          label:
                            "Beschermingstafel organiseren binnen Zorg- en Veiligheidshuis Curaçao",
                        },
                        {
                          value: 35211,
                          label: "Doorverwijzen (maatwerk).",
                        },
                        {
                          value: 35210,
                          label:
                            "Vrijwillige hulpverlening (o.a. integrale aanpak of intensiveren).",
                        },
                        {
                          value: 35209,
                          label:
                            "Verzoek tot onderzoek (o.a. jeugdbeschermende maatregel).",
                        },
                      ]}
                    />
                    <InputField
                      type="textarea"
                      label="Toelichting verwachting"
                      name={"70441"}
                      rules={{ required: true }}
                      {...this.props}
                      errors={this.props.formState.errors}
                    />
                    <InputField
                      type="select"
                      label="Veiligheidsschaal"
                      name={"70443"}
                      {...this.props}
                      errors={this.props.formState.errors}
                      options={[
                        {
                          value: 35223,
                          label: "10",
                        },
                        {
                          value: 35222,
                          label: "9",
                        },
                        {
                          value: 35221,
                          label: "8",
                        },
                        {
                          value: 35220,
                          label: "7",
                        },
                        {
                          value: 35219,
                          label: "6",
                        },
                        {
                          value: 35218,
                          label: "5",
                        },
                        {
                          value: 35217,
                          label: "4",
                        },
                        {
                          value: 35216,
                          label: "3",
                        },
                        {
                          value: 35215,
                          label: "2",
                        },
                        {
                          value: 35214,
                          label: "1",
                        },
                        {
                          value: 35213,
                          label: "0",
                        },
                      ]}
                    />
                    <InputField
                      type="textarea"
                      label="Licht in enkele woorden toe wat dit cijfer voor jou betekent"
                      name={"70444"}
                      rules={{ required: true }}
                      {...this.props}
                      errors={this.props.formState.errors}
                    />
                  </div>
                </div>
                <div className="col-span-4">
                  <button
                    type="submit"
                    className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center"
                  >
                    Verstuur
                  </button>
                </div>
              </Form>
            ) : (
              <Form
                className="flex flex-col gap-4 w-full items-start"
                {...this.props}
                onSubmit={this.submitForm}
                defDossier={this.state.defDossier}
              >
                <div className="flex gap-5 flex-wrap">
                  <div className="flex flex-col gap-2">
                    <InputField
                      type="date"
                      defaultValue={new Date().toLocaleDateString("en-CA")}
                      name={"70226"}
                      rules={{
                        required: {
                          value: true,
                          message: "Datum aanmelding is required",
                        },
                      }}
                      {...this.props}
                      errors={this.props.formState.errors}
                      hide
                    />
                    <InputField
                      defaultValue={35177}
                      type="select"
                      label="Wat wilt u registreren?"
                      name={"70213"}
                      rules={{ required: true }}
                      {...this.props}
                      errors={this.props.formState.errors}
                      options={[
                        {
                          value: 35177,
                          label: "Melding",
                        },
                        {
                          value: 35176,
                          label: "Advies",
                        },
                      ]}
                      onChange={(value) => {
                        this.setState({ isMelding: value == 35177 });
                      }}
                    />

                    <InputField
                      type="select"
                      label="Afkomst"
                      name={"70231"}
                      rules={{ required: true }}
                      {...this.props}
                      errors={this.props.formState.errors}
                      options={[
                        {
                          value: 35180,
                          label: "Anoniem",
                        },
                        {
                          value: 35179,
                          label: "Professional",
                        },
                        {
                          value: 35178,
                          label: "Buger",
                        },
                      ]}
                    />

                    <InputField
                      type="text"
                      placeholder="Gegevens van de adviesvrager"
                      label="Naam adviesvrager"
                      name={"70216"}
                      rules={{ required: true }}
                      {...this.props}
                      errors={this.props.formState.errors}
                    />

                    <InputField
                      type="text"
                      label="Instantie en functie "
                      name={"70217"}
                      rules={{ required: true }}
                      {...this.props}
                      errors={this.props.formState.errors}
                    />

                    <InputField
                      type="phone"
                      label="Telefoonnummers"
                      name={"70218"}
                      rules={{ required: "This field is required" }}
                      {...this.props}
                      errors={this.props.formState.errors}
                    />

                    <InputField
                      type="email"
                      label="E-mailadres melder"
                      name={"70219"}
                      rules={{ required: true }}
                      {...this.props}
                      errors={this.props.formState.errors}
                    />

                    <InputField
                      type="select"
                      label="Soort adviesgesprek"
                      name={"70220"}
                      rules={{ required: true }}
                      {...this.props}
                      errors={this.props.formState.errors}
                      options={[
                        {
                          value: 35185,
                          label: "Eerste adviesgesprek",
                        },
                        {
                          value: 35184,
                          label: "Persoonlijk",
                        },
                        {
                          value: 35183,
                          label: "Binnenloper",
                        },
                        {
                          value: 35182,
                          label: "Online",
                        },
                        {
                          value: 35182,
                          label: "Telefonisch",
                        },
                      ]}
                    />

                    <InputField
                      type="select"
                      label="Hoeveel adviezen"
                      name={"70221"}
                      rules={{ required: true }}
                      {...this.props}
                      errors={this.props.formState.errors}
                      options={[
                        {
                          value: 35188,
                          label: "3e adviesgesprek",
                        },
                        {
                          value: 35187,
                          label: "2e advesgesprek",
                        },
                        {
                          value: 35186,
                          label: "1e advesgesprek",
                        },
                      ]}
                    />

                    <InputField
                      type="select"
                      label="Bewerken weergaveveld"
                      name={"70222"}
                      rules={{ required: true }}
                      {...this.props}
                      errors={this.props.formState.errors}
                      options={[
                        {
                          value: 35193,
                          label: "Voorheen in begeleiding",
                        },
                        {
                          value: 35192,
                          label: "In begeleiding",
                        },
                        {
                          value: 35191,
                          label: "Familielid",
                        },
                        {
                          value: 35190,
                          label: "Directe betrokkene",
                        },
                        {
                          value: 35189,
                          label: "2e stap van beschermingscode",
                        },
                      ]}
                    />
                    <InputField
                      type="textarea"
                      label="Hulpvraag"
                      name={"70224"}
                      rules={{ required: true }}
                      {...this.props}
                      errors={this.props.formState.errors}
                    />
                    <InputField
                      type="select"
                      label="Informeren en adviseren "
                      name={"70223"}
                      rules={{ required: true }}
                      {...this.props}
                      errors={this.props.formState.errors}
                      options={[
                        {
                          value: 35198,
                          label:
                            "De ondersteuning die ProtehaMi kan bieden of organiseren",
                        },
                        {
                          value: 35197,
                          label:
                            "De stappen die direct betrokkene zelf kan zetten",
                        },
                        {
                          value: 35196,
                          label: "De bestaande situatie te doorbreken",
                        },
                        {
                          value: 35195,
                          label: "Het in stand houden van het geweld",
                        },
                        {
                          value: 35194,
                          label: "De gevolgenb van het geweld",
                        },
                      ]}
                    />
                    <InputField
                      type="textarea"
                      label="Toelichting informeren"
                      name={"70232"}
                      rules={{ required: true }}
                      {...this.props}
                      errors={this.props.formState.errors}
                    />
                    <InputField
                      type="select"
                      label="Vervolgadvies"
                      name={"70225"}
                      rules={{ required: true }}
                      {...this.props}
                      errors={this.props.formState.errors}
                      options={[
                        {
                          value: 35203,
                          label:
                            "Casus aanmelden bij Zorg- en Veiligheidshuis Curaçao",
                        },
                        {
                          value: 35202,
                          label: "Afspraak voor volgend adviesgesprek",
                        },
                        {
                          value: 35201,
                          label:
                            "Adviesvrager zelf verantwoordelijk voor vervolgstappen",
                        },
                        {
                          value: 35200,
                          label: "Omzetten van een advies naar melding",
                        },
                        {
                          value: 35199,
                          label: "Ambtshalve melding",
                        },
                      ]}
                    />
                     <InputField
                      type="textarea"
                      label="Afspraken"
                      name={"70230"}
                      rules={{ required: true }}
                      {...this.props}
                      errors={this.props.formState.errors}
                    />
                  </div>
                </div>
                <div className="col-span-4">
                  <button
                    type="submit"
                    className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center"
                  >
                    Verstuur
                  </button>
                </div>
              </Form>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default ZVHC2Form;
